import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { loadCurrentUser, loadCurrentUserSuccess } from './currentUser.actions';
import { ApiResponse } from '@shared';
import { ToastrService } from 'ngx-toastr';
import { SystemAdminService } from '@services';

@Injectable()
export class CurrentUserEffects {
  constructor(
    private actions$: Actions,
    private systemAdminService: SystemAdminService,
    private toast: ToastrService,
  ) {}
  loadCurrentUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadCurrentUser),
      mergeMap(() =>
        this.systemAdminService.getCurrentAdmin().pipe(
          map((response: ApiResponse) => {
            if (response.status) {
              const currentUser = response.data;
              return loadCurrentUserSuccess({ currentUser });
            } else {
              this.toast.error(response.message);
              return { type: '[Current User] Load Current User Failed' };
            }
          }),
          catchError((error: any) => {
            this.toast.error(error);
            return of({ type: '[Current User] Load Current User Failed' });
          }),
        ),
      ),
    ),
  );
}
